import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=52d2734f&scoped=true"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"
import style0 from "./manage.vue?vue&type=style&index=0&id=52d2734f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2734f",
  null
  
)

export default component.exports